import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Landing from "./pages/Landing";
import Legal from "./pages/Legal";
import ApprovePage from "./pages/ApprovePage";
import { CookieConsent } from "./components/CookieConsent";
import Login from "./pages/Login";
import SuperAdmin from "./pages/SuperAdmin";
import CompanyAdmin from "./pages/CompanyAdmin";
import ProcessorDashboard from "./pages/ProcessorDashboard";
import Kiosk from "./pages/Kiosk";
import Mobile from "./pages/Mobile";
import EmployeePortal from "./pages/EmployeePortal";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400">
        <div className="animate-pulse font-mono">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role === "super_admin" && user.role !== "super_admin")
    return <Navigate to={user.role === "processor" ? "/processor" : "/admin"} replace />;
  if (role === "processor" && user.role !== "processor")
    return <Navigate to={user.role === "super_admin" ? "/super" : "/admin"} replace />;
  if (role === "company_admin" && !["company_admin", "processor"].includes(user.role))
    return <Navigate to="/super" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/privacy" element={<Legal doc="privacy" />} />
              <Route path="/cookies" element={<Legal doc="cookies" />} />
              <Route path="/terms" element={<Legal doc="terms" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/kiosk" element={<Kiosk />} />
              <Route path="/kiosk/:companyId" element={<Kiosk />} />
              <Route path="/mobile" element={<Mobile />} />
              <Route path="/mobile/:companyId" element={<Mobile />} />
              <Route path="/portal/:companyId" element={<EmployeePortal />} />
              <Route path="/approve/:token" element={<ApprovePage />} />
              <Route path="/super" element={<Protected role="super_admin"><SuperAdmin /></Protected>} />
              <Route path="/processor" element={<Protected role="processor"><ProcessorDashboard /></Protected>} />
              <Route path="/admin" element={<Protected role="company_admin"><CompanyAdmin /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <CookieConsent />
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
